<template>
  <svg :width="size" :height="size"
    viewBox="0 0 22 18.8041237" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Pages" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="Dashboard" transform="translate(-1786, -249.5979)" :fill="color"  fill-rule="nonzero">
        <g id="Group-29" transform="translate(1317, 211)">
          <g  id="warning_FILL1_wght400_GRAD0_opsz24" transform="translate(469, 38.5979)">
            <path id="Shape" d="M0,18.8041237 L11,0 L22,18.8041237 L0,18.8041237 Z M11,15.8350515 C11.2833333,15.8350515 11.5208333,15.7402062 11.7125,15.5505155 C11.9041667,15.3608247 12,15.1257732 12,14.8453608 C12,14.5649485 11.9041667,14.3298969 11.7125,14.1402062 C11.5208333,13.9505155 11.2833333,13.8556701 11,13.8556701 C10.7166667,13.8556701 10.4791667,13.9505155 10.2875,14.1402062 C10.0958333,14.3298969 10,14.5649485 10,14.8453608 C10,15.1257732 10.0958333,15.3608247 10.2875,15.5505155 C10.4791667,15.7402062 10.7166667,15.8350515 11,15.8350515 Z M10,12.8659794 L12,12.8659794 L12,7.91752577 L10,7.91752577 L10,12.8659794 Z">
          </path>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'IconWarning',
    props: {
       color: {
        type: String,
        default: "#E5A212",
       },
       size: {
        type: String,
        default: "1.5rem"
       }
    }
  }
</script>